<template lang="pug">
div
    div.text-center
        img(v-bind:src="logo" width="80px")

        div.col-sm-12.text-center.p-t-1
            small.block(v-if="outlet.details") {{ outlet.details.company_name }}
            small.block {{ outlet.name }}
            small.block {{ outlet.address }}
            small.block {{ receiptDateFormatModal(receipt.settled_date, outlet.preference.timezone_offset ) }}
            small.block(v-if="outlet.preference") Phone: {{ outlet.preference.phone }}
            small.block Site: {{ outlet.code }}

    div.row(v-if="!receipt.central")
        div.col-sm-12
            hr

            div.row
                div.col-xs-4
                    small.pull-left Invoice #
                    br
                    h5.pull-left {{ receiptNumberFormat(receipt) }}

        div.col-sm-12
            hr

            div.row(v-if="receipt.attendant_session_id && terminalType && paymentType")
                div.col-xs-4(v-if="receipt.cashier")
                    small.pull-left Attendant
                    br
                    h5.pull-left {{ receipt.cashier.name }}

                div.col-xs-4
                    small.pull-left Attendant Card No.
                    br
                    h5.pull-left {{ checkAttendantMeta.card }}

                div.col-xs-4
                    small.pull-left Attendant Till #
                    br
                    h5.pull-left {{ receipt.attendant_session.sequence_number }}

        div.col-sm-12(v-if="receipt.attendant_session")
            hr

    div.row(v-else)
        div.col-sm-12
            hr

        div.col-sm-12
            //div.row(v-if="!hasOrderFuel && !retailMode")
            //    div.col-xs-5
            //        small.pull-left Table
            //        br
            //        h5.pull-left {{ hasTable ? table.name : 'TAKEAWAY'  }}
            //    div.col-xs-3
            //        small.pull-left Pax
            //        br
            //        h5.pull-left {{ hasTable ? orderTable.pax : 'N/A' }}
            //    div.col-xs-4(v-if="cashier")
            //        small.pull-left Cashier
            //        br
            //        h5.pull-left {{ cashier.name }}

            //div.row(v-if="!hasOrderFuel && retailMode")
            div.row
                div.col-xs-4.text-break
                    small.pull-left POS
                    br
                    h5.pull-left {{ receipt.central.name }}

                div.col-xs-4(v-if="cashier")
                    small.pull-left Staff
                    br
                    h5.pull-left {{ cashier.name }}

                div.col-xs-4(v-if="cashier")
                    small.pull-left Invoice #
                    br
                    h5.pull-left {{ receiptNumberFormat(receipt) }}

            div.row
                div.col-xs-4(v-if="cashier")
                    small.pull-left Shift #
                    br
                    h5.pull-left {{ receipt.drawer_session.sequence_number }}

            //div.row(v-if="hasOrderFuel")
            //    div.col-xs-4
            //        small.block Fuel
            //        h5 {{ orderFuel.fuel.name }}
            //
            //    div.col-xs-4
            //        small.block Amount
            //        h5.m-b-0 RM {{ orderFuel.amount }}
            //        small.block {{ orderFuel.volume }} l @ RM {{ orderFuel.price }}
            //
            //    div.col-xs-4(v-if="cashier")
            //        small.block Cashier
            //        h5 {{ cashier.name }}
            //
            //div.row.m-t-sm(v-if="hasOrderFuel && orderFuel.refund != null")
            //    div.col-xs-4
            //    div.col-xs-4
            //        small.block Refund
            //        h5.m-b-0 RM {{ orderFuel.refund.total_amount }}
            //        small.block {{ receiptDateFormat(orderFuel.refund.refunded_at) }}
            //    div.col-xs-4(v-if="orderFuel.refund.staff != null")
            //        small.block Cashier
            //        h5 {{ orderFuel.refund.staff.name }}

        div.col-sm-12
            hr
</template>

<script>
import Feature from '@js/plugins/feature';
import receiptMixin from '../../mixins/receipt';
import { mapGetters } from 'vuex';
import Unleash from '@js/plugins/unleash';
import Auth from '@js/plugins/auth';

export default {
    mixins: [receiptMixin],

    computed: {
        ...mapGetters('transaction', [
            'receipt',
            'outlet',
            'table',
            'orderFuel',
            'orderTable',
            'cashier',
            'hasTable',
            'grandTotal',
            'payments',
        ]),

        retailMode() {
            return Feature.hasFeature('retail');
        },

        hasOrderFuel() {
            return this.orderFuel != null;
        },

        payment() {
            let payment = this.payments.find(
                p => p.name === 'EDC' || 'IPT' || 'OPT',
            );

            if (!_.isEmpty(payment)) {
                return payment;
            }

            return null;
        },

        terminalType() {
            let terminalType = this.receipt.payments.find(
                p => p.terminal_type === 'OPT',
            );

            if (!_.isEmpty(terminalType)) {
                return true;
            }

            return false;
        },

        paymentType() {
            let paymentType = this.receipt.payments.find(
                p => p.payment.type === 0,
            );

            if (!_.isEmpty(paymentType)) {
                return true;
            }

            return false;
        },

        checkAttendantMeta() {
            if (this.receipt.attendant_session) {
                let checkAttendantMeta = this.receipt.payments.find(
                    p => p.meta !== null,
                );

                if (!_.isEmpty(checkAttendantMeta)) {
                    return checkAttendantMeta.meta;
                }
            }

            return null;
        },

        enableUnleash() {
            return Unleash.hasFeature('eps_report');
        },

        logo() {
            return Auth.franchise().logo;
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/receipt/details.vue